export default "__VITE_ASSET__CnCE384V__"